import { ROLE_GROUPS, ROLE_LABELS, type BlastRoleKey } from '../../lib/campaignRoles';

interface Props {
  selected: readonly BlastRoleKey[];
  crmContacts: boolean;
  disabled: boolean;
  onToggleRole: (role: BlastRoleKey) => void;
  onToggleCrmContacts: () => void;
}

const CHECKBOX = 'rounded border-gray-300 text-blast-600 focus:ring-blast-500';

/** Audience source checkboxes, grouped by who the recipients are to the team. */
export function AudienceRoleGroups({ selected, crmContacts, disabled, onToggleRole, onToggleCrmContacts }: Props) {
  return (
    <div className="space-y-4">
      {ROLE_GROUPS.map((group) => (
        <fieldset key={group.heading}>
          <legend className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2">{group.heading}</legend>
          <div className="space-y-2">
            {group.roles.map((role) => (
              <label key={role} className="flex items-center gap-2">
                <input type="checkbox" className={CHECKBOX} checked={selected.includes(role)} onChange={() => onToggleRole(role)} disabled={disabled} />
                <span className="text-sm text-gray-700 dark:text-gray-300">{ROLE_LABELS[role]}</span>
              </label>
            ))}
          </div>
        </fieldset>
      ))}
      <label className="flex items-center gap-2">
        <input type="checkbox" className={CHECKBOX} checked={crmContacts} onChange={onToggleCrmContacts} disabled={disabled} />
        <span className="text-sm text-gray-700 dark:text-gray-300">CRM contacts</span>
      </label>
    </div>
  );
}
